import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'sb-dropdown-box',
  templateUrl: './sb-dropdown-box.component.html',
  styleUrls: ['./sb-dropdown-box.component.scss'],
  standalone: false,
})
export class SbDropdownBoxComponent implements OnInit {
  @Input() options: string[];

  @Output() optionSelected: EventEmitter<string> = new EventEmitter();

  @ViewChild('thedropdown')
  dropdownchild?: any;

  visible: boolean = false;

  blur: boolean = true;

  @Input()
  disabled: boolean = false;

  constructor() {}

  ngOnInit() {
    if (!this.options) {
      this.options = [];
    }
  }

  onClick(option: string) {
    if (!this.disabled) {
      if (option) {
        this.optionSelected.emit(option);
      }

      this.blur = true;

      this.hide();
    }
  }

  show() {
    // this.visible = true;
  }

  hide() {
    if (this.blur) {
      this.visible = false;
    }
  }

  preventBlur() {
    this.blur = false;
  }

  click() {
    if (!this.disabled) {
      this.visible = !this.visible;

      if (this.visible) {
        setTimeout(() => {
          this.dropdownchild.nativeElement.focus();
        }, 1);

        this.blur = true;
      }
    }
  }
}
